import { actionCreator } from 'utils';
import * as JobResultTypes from '../types/jobResultTypes';

// L O A D   J O B   R E S U L T
export function loadJobResult() {
    return {
        type: JobResultTypes.LOAD_JOB_RESULT,
    };
}

export function loadJobResultRes(data) {
    return {
        type: actionCreator(JobResultTypes.LOAD_JOB_RESULT, 'res'),
        data,
    };
}

export function loadJobResultErr() {
    return {
        type: actionCreator(JobResultTypes.LOAD_JOB_RESULT, 'err'),
    };
}
// L O A D   J O B   R E S U L T


// S E T   J O B   R E S U L T   F I L T E R S
export function setJobResultFilters(key, value) {
    return {
        type: JobResultTypes.SET_JOB_RESULT_FILTERS,
        key,
        value,
    };
}
// S E T   J O B   R E S U L T   F I L T E R S


// R E S E T   J O B   R E S U L T   F I L T E R S
export function resetJobResultFilters() {
    return {
        type: JobResultTypes.RESET_JOB_RESULT_FILTERS,
    };
}

export function resetJobResultFiltersRes(data) {
    return {
        type: actionCreator(JobResultTypes.RESET_JOB_RESULT_FILTERS, 'res'),
        data,
    };
}
// R E S E T   J O B   R E S U L T   F I L T E R S


// S E T   J O B   R E S U L T   P A G I N A T I O N
export function setJobResultPagination(key, pagination) {
    return {
        type: JobResultTypes.SET_JOB_RESULT_PAGINATION,
        key,
        pagination,
    };
}
// S E T   J O B   R E S U L T   P A G I N A T I O N


// T O G G L E   J O B   R E S U L T   S T E P S
export function toggleJobResultSteps(data) {
    return {
        type: JobResultTypes.TOGGLE_JOB_RESULT_STEPS,
        data,
    };
}
// T O G G L E   J O B   R E S U L T   S T E P S

// A D D   N E W   P A L E T T E
export function addNewPalette(data) {
    return {
        type: JobResultTypes.ADD_NEW_PALETTE,
        data,
    };
}

export function addNewPaletteRes() {
    return {
        type: actionCreator(JobResultTypes.ADD_NEW_PALETTE, 'res'),
    };
}

export function addNewPaletteErr() {
    return {
        type: actionCreator(JobResultTypes.ADD_NEW_PALETTE, 'err'),
    };
}
// A D D   N E W   P A L E T T E

// P R I N T   P A L E T T E
export function printPalette(data) {
    return {
        type: JobResultTypes.PRINT_PALETTE,
        data,
    };
}

export function printPaletteRes() {
    return {
        type: actionCreator(JobResultTypes.PRINT_PALETTE, 'res'),
    };
}

export function printPaletteErr() {
    return {
        type: actionCreator(JobResultTypes.PRINT_PALETTE, 'err'),
    };
}
// P R I N T   P A L E T T E

// S E T   C H E C K E D   J O B   R E S U L T
export function setCheckedJobResult(ids) {
    return {
        type: JobResultTypes.SET_CHECKED_JOB_RESULT,
        ids,
    };
}
// S E T   C H E C K E D   J O B   R E S U L T

// S E T   C H E C K E D   J O B   R E S U L T   R E C O R D
export function setCheckedJobResultRecord(data) {
    return {
        type: JobResultTypes.SET_CHECKED_JOB_RESULT_RECORD,
        data,
    };
}

// S E T   C H E C K E D   J O B   R E S U L T   R E C O R D

// S E T   J O B   R E S U L T   S O R T
export function setJobResultSort(key, type) {
    return {
        type: JobResultTypes.SET_JOB_RESULT_SORT,
        sort: {
            key,
            type,
        },
    };
}
// S E T   J O B   R E S U L T   S O R T

// A D D   N E W  P A L E T T E   P O P U P   V I S I B I L I T Y
export function showAddNewPalettePopup() {
    return {
        type: JobResultTypes.SHOW_ADD_NEW_PALETTE_POPUP,
    };
}

export function hideAddNewPalettePopup() {
    return {
        type: JobResultTypes.HIDE_ADD_NEW_PALETTE_POPUP,
    };
}
// A D D   N E W  P A L E T T E   P O P U P   V I S I B I L I T Y

// U P D A T E   F O R M
export function updateJobResults(data) {
    return {
        type: JobResultTypes.UPDATE_JOB_RESULTS,
        data,
    };
}

export function updateJobResultsRes(loading, success) {
    return {
        type: actionCreator(JobResultTypes.UPDATE_JOB_RESULTS, 'res'),
        loading,
        success,
    };
}

export function updateJobResultsErr() {
    return {
        type: actionCreator(JobResultTypes.UPDATE_JOB_RESULTS, 'err'),
    };
}
// U P D A T E   F O R M

// F O R C E _ P R I N T _ P A L E T T E
export function forcePrintPalette(data) {
    return {
        type: JobResultTypes.FORCE_PRINT_PALETTE,
        data,
    };
}

export function forcePrintPaletteRes(loading, success) {
    return {
        type: actionCreator(JobResultTypes.FORCE_PRINT_PALETTE, 'res'),
        loading,
        success,
    };
}

export function forcePrintPaletteErr() {
    return {
        type: actionCreator(JobResultTypes.FORCE_PRINT_PALETTE, 'err'),
    };
}
// F O R C E _ P R I N T _ P A L E T T E

// D E L E T E   J O B   R E S U L T
export function deleteJobResult(id) {
    return {
        type: JobResultTypes.DELETE_JOB_RESULT,
        id,
    };
}

export function deleteJobResultRes() {
    return {
        type: actionCreator(JobResultTypes.DELETE_JOB_RESULT, 'res'),
    };
}

export function deleteJobResultErr() {
    return {
        type: actionCreator(JobResultTypes.DELETE_JOB_RESULT, 'err'),
    };
}
// D E L E T E   J O B   R E S U L T

// G E N E R A T E   T E M P O R A R Y   P A P E R
export function generateTemporaryPaper(data) {
    return {
        type: JobResultTypes.GENERATE_TEMPORARY_PAPER,
        data,
    };
}

export function generateTemporaryPaperRes() {
    return {
        type: actionCreator(JobResultTypes.GENERATE_TEMPORARY_PAPER, 'res'),
    };
}

export function generateTemporaryPaperErr() {
    return {
        type: actionCreator(JobResultTypes.GENERATE_TEMPORARY_PAPER, 'err'),
    };
}
// G E N E R A T E   T E M P O R A R Y   P A P E R
